import { render, staticRenderFns } from "./LogisticsTrack.vue?vue&type=template&id=cb007246&scoped=true&"
import script from "./LogisticsTrack.vue?vue&type=script&lang=js&"
export * from "./LogisticsTrack.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsTrack.vue?vue&type=style&index=0&id=cb007246&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb007246",
  null
  
)

export default component.exports